import { render, staticRenderFns } from "./WebLandingTextBox.vue?vue&type=template&id=2bbbe1c7&scoped=true"
import script from "./WebLandingTextBox.vue?vue&type=script&lang=js"
export * from "./WebLandingTextBox.vue?vue&type=script&lang=js"
import style0 from "./WebLandingTextBox.vue?vue&type=style&index=0&id=2bbbe1c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbbe1c7",
  null
  
)

export default component.exports